import { useTranslation } from 'react-i18next';

const PUBLIC_URL = process.env.PUBLIC_URL || '';
const LOADER_DARK = PUBLIC_URL + '/images/fayda_loader_dark.gif';
const LOADER_LIGHT = PUBLIC_URL + '/images/fayda_loader_light.gif';

const dynamicSize = {
  small: {
    width: '1.5rem',
    height: '1.5rem',
  },
  medium: {
    width: '2.5rem',
    height: '2.5rem',
  },
  large: {
    width: '5rem',
    height: '5rem',
  },
};

const LoadingIndicator = ({
  message,
  size,
  msgParam,
  i18nKeyPrefix = 'loadingMsgs',
  className,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: i18nKeyPrefix });

  return (
    <>
      <div
        role="status"
        className={
          'flex justify-center items-center loading-indicator ' + className
        }
      >
        <img
          src={LOADER_DARK}
          alt=""
          draggable={false}
          style={dynamicSize[size]}
          className="vf-fayda-loader vf-fayda-loader-for-light mr-2 rtl:ml-2 object-contain pointer-events-none"
        />
        <img
          src={LOADER_LIGHT}
          alt=""
          draggable={false}
          style={dynamicSize[size]}
          className="vf-fayda-loader vf-fayda-loader-for-dark mr-2 rtl:ml-2 object-contain pointer-events-none"
        />
        <span className="sr-only">Loading...</span>
        {message && (
          <span className="loading-indicator-label">
            {t(message, msgParam)}
          </span>
        )}
      </div>
    </>
  );
};

LoadingIndicator.defaultProps = {
  size: 'medium',
};

export default LoadingIndicator;
